module.exports = __webpack_public_path__ + "static/media/login-background.6cebc160.png";